import {SideBySide} from './side-by-side'

export default SideBySide
